import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { CurrentPdvProvider } from "./contexts/CurrentPdvContext";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PDVListPage from "./pages/PDVListPage";
import PDVDetailPage from "./pages/PDVDetailPage";
import PDVDocumentsPage from "./pages/PDVDocumentsPage";
import DocumentsPage from "./pages/DocumentsPage";
import TrainingPage from "./pages/TrainingPage";
import SafetyChecksPage from "./pages/SafetyChecksPage";
import CalendarPage from "./pages/CalendarPage";
import NotificationsPage from "./pages/NotificationsPage";
import NotificationsSettingsPage from "./pages/NotificationsSettingsPage";
import ProfilePage from "./pages/ProfilePage";
import UsersPage from "./pages/UsersPage";
import RegistrationsPage from "./pages/RegistrationsPage";
import LicensesPage from "./pages/LicensesPage";
import HaccpLicensesPage from "./pages/HaccpLicensesPage";
import TeachersPage from "./pages/TeachersPage";
import VirtualClassroomsPage from "./pages/VirtualClassroomsPage";
import TeacherInvoicesPage from "./pages/TeacherInvoicesPage";
import PersonnelPage from "./pages/PersonnelPage";
import CertificatesPage from "./pages/CertificatesPage";
import DocumentGeneratorPage from "./pages/DocumentGeneratorPage";
import TemplateVariablesPage from "./pages/TemplateVariablesPage";
import DpiCatalogPage from "./pages/DpiCatalogPage";
import BanchiFrigoPage from "./pages/BanchiFrigoPage";
import SignRegisterPage from "./pages/SignRegisterPage";
import VerifyAttestatoPage from "./pages/VerifyAttestatoPage";
import DocxTemplatesManagerPage from "./pages/DocxTemplatesManagerPage";
import DocumentsMatrixPage from "./pages/DocumentsMatrixPage";
import MedicalVisitsPage from "./pages/MedicalVisitsPage";
import TrainingMaterialsPage from "./pages/TrainingMaterialsPage";
import AttendanceRegistersPage from "./pages/AttendanceRegistersPage";
import GroundInspectionsPage from "./pages/GroundInspectionsPage";
import AziendaPage from "./pages/AziendaPage";
import ScadenzePage from "./pages/ScadenzePage";
import DvrDuvriPage from "./pages/DvrDuvriPage";
import HaccpPage from "./pages/HaccpPage";
import HaccpTemperaturePage from "./pages/HaccpTemperaturePage";
import HaccpSamplesPage from "./pages/HaccpSamplesPage";
import HaccpCleaningPage from "./pages/HaccpCleaningPage";
import HaccpAllergensPage from "./pages/HaccpAllergensPage";
import HaccpInspectionPage from "./pages/HaccpInspectionPage";
import LabAnalysisPage from "./pages/LabAnalysisPage";
import EnrolledPersonnelPage from "./pages/EnrolledPersonnelPage";
import TrainingTestsPage from "./pages/TrainingTestsPage";
import TestSubmissionsKanbanPage from "./pages/TestSubmissionsKanbanPage";
import TrainingSessionsPage from "./pages/TrainingSessionsPage";
import RegisterTemplatesPage from "./pages/RegisterTemplatesPage";
import SafetyProgramsPage from "./pages/SafetyProgramsPage";
import StudioDashboardPage from "./pages/StudioDashboardPage";
import StudioClientiPage from "./pages/StudioClientiPage";
import StudioCommessePage from "./pages/StudioCommessePage";
import StudioPreventiviPage from "./pages/StudioPreventiviPage";
import StudioPagamentiPage from "./pages/StudioPagamentiPage";
import StudioScadenzePage from "./pages/StudioScadenzePage";
import StudioInsegnePage from "./pages/StudioInsegnePage";
import ProfessionistaPage from "./pages/ProfessionistaPage";
import ModulisticaPratichePage from "./pages/ModulisticaPratichePage";
import HaccpSchedeTecnichePage from "./pages/HaccpSchedeTecnichePage";
import DichiarazioneHaccpPage from "./pages/DichiarazioneHaccpPage";
import DichiarazioneSicurezzaPage from "./pages/DichiarazioneSicurezzaPage";
import VerbaliPrelievoPage from "./pages/VerbaliPrelievoPage";
import SchedePreoperativeHaccpPage from "./pages/SchedePreoperativeHaccpPage";
import CalendarioImpegniPage from "./pages/CalendarioImpegniPage";
import FatturePage from "./pages/FatturePage";
import TrainingCertificatesPage from "./pages/TrainingCertificatesPage";
import MedicalRecordsPage from "./pages/MedicalRecordsPage";
import EmployeesOverviewPage from "./pages/EmployeesOverviewPage";
import PublicRegisterPage from "./pages/PublicRegisterPage";
import PublicTestPage from "./pages/PublicTestPage";
import ContractsPage from "./pages/ContractsPage";
import ContractSignPage from "./pages/ContractSignPage";
import PlatformsPage from "./pages/PlatformsPage";
import AgenteCollabIscrizioniPage from "./pages/AgenteCollabIscrizioniPage";
import VerbaliAslPage from "./pages/VerbaliAslPage";
import HaccpManualePage from "./pages/HaccpManualePage";
import PrevenzioneIncendiPage from "./pages/PrevenzioneIncendiPage";
import TemplateEditorPage from "./pages/TemplateEditorPage";
import OnlineUsersPage from "./pages/OnlineUsersPage";
import DelegaDocfaPage from "./pages/DelegaDocfaPage";
import LibroIngredientiPage from "./pages/LibroIngredientiPage";
import SchedeProdottoPage from "./pages/SchedeProdottoPage";
import SignFlowPage from "./pages/SignFlowPage";
import ImpiantiAudiovisiviPage from "./pages/ImpiantiAudiovisiviPage";
import DocenteKeysPage from "./pages/DocenteKeysPage";
import DiagnosticaPage from "./pages/DiagnosticaPage";
import PianiSanitariPage from "./pages/PianiSanitariPage";
import PianoSanitarioDetailPage from "./pages/PianoSanitarioDetailPage";
import UserSignaturePage from "./pages/UserSignaturePage";
import MatricePrelieviPage from "./pages/MatricePrelieviPage";
import DelegheePage from "./pages/DelegheePage";
import DocentePptPage from "./pages/DocentePptPage";
import NotificationSettingsPage from "./pages/NotificationSettingsPage";
import SelectContextPage from "./pages/SelectContextPage";  // v1.3.6
import VersionMismatchBanner from "./components/VersionMismatchBanner";  // v1.3.7
import Layout from "./components/Layout";
import "./App.css";
import { useCurrentPdv } from "./contexts/CurrentPdvContext";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const { needsContextSelection } = useCurrentPdv();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (adminOnly && user.role !== 'super_admin') {
    return <Navigate to="/" replace />;
  }
  
  // v1.3.6 — Hard-gate context switcher: utenti multi-scope devono scegliere azienda+UL
  if (needsContextSelection && needsContextSelection()) {
    return <Navigate to="/select-context" replace />;
  }
  
  return children;
};

// v1.3.6 — Variante senza hard-gate per la pagina /select-context (altrimenti loop infinito)
const ProtectedRouteNoGate = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <CurrentPdvProvider>
      <BrowserRouter>
        <VersionMismatchBanner />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/public/registro/:token" element={<PublicRegisterPage />} />
          <Route path="/test/:token" element={<PublicTestPage />} />
          <Route path="/public/test/:token" element={<PublicTestPage />} />
          <Route path="/sign-register/:token" element={<SignRegisterPage />} />
          <Route path="/verify/:code" element={<VerifyAttestatoPage />} />
          <Route path="/contratto-firma/:token" element={<ContractSignPage />} />
          {/* v1.3.6 — Pagina di scelta contesto (NON dentro Layout, è schermata full-screen) */}
          <Route path="/select-context" element={
            <ProtectedRouteNoGate><SelectContextPage /></ProtectedRouteNoGate>
          } />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/azienda" element={<AziendaPage />} />
                    <Route path="/pdv" element={<PDVListPage />} />
                    <Route path="/pdv/:id" element={<PDVDetailPage />} />
                    <Route path="/pdv/:id/documents" element={<PDVDocumentsPage />} />
                    <Route path="/documents" element={<DocumentsPage />} />
                    <Route path="/scadenze" element={<ScadenzePage />} />
                    <Route path="/dvr-duvri" element={<DvrDuvriPage />} />
                    <Route path="/haccp" element={<HaccpPage />} />
                    <Route path="/banchi-frigo" element={<BanchiFrigoPage />} />
                    <Route path="/haccp-temperature" element={<HaccpTemperaturePage />} />
                    <Route path="/haccp-campioni" element={<HaccpSamplesPage />} />
                    <Route path="/haccp-cleaning" element={<HaccpCleaningPage />} />
                    <Route path="/haccp-allergens" element={<HaccpAllergensPage />} />
                    <Route path="/haccp-inspection" element={<HaccpInspectionPage />} />
                    <Route path="/lab-analysis" element={<LabAnalysisPage />} />
                    <Route path="/training" element={<TrainingPage />} />
                    <Route path="/safety-checks" element={<SafetyChecksPage />} />
                    <Route path="/calendar" element={<CalendarPage />} />
                    <Route path="/notifications" element={<NotificationsPage />} />
                    <Route path="/users" element={<UsersPage />} />
                    <Route path="/registrations" element={<RegistrationsPage />} />
                    <Route path="/licenses" element={<LicensesPage />} />
                    <Route path="/haccp-licenses" element={<HaccpLicensesPage />} />
                    <Route path="/teachers" element={<TeachersPage />} />
                    <Route path="/enrolled-personnel" element={<EnrolledPersonnelPage />} />
                    <Route path="/virtual-classrooms" element={<VirtualClassroomsPage />} />
                    <Route path="/teacher-invoices" element={<TeacherInvoicesPage />} />
                    <Route path="/training-tests" element={<TrainingTestsPage />} />
                    <Route path="/test-submissions" element={<TestSubmissionsKanbanPage />} />
                    <Route path="/personnel" element={<PersonnelPage />} />
                    <Route path="/certificates" element={<CertificatesPage />} />
                    <Route path="/document-generator" element={<DocumentGeneratorPage />} />
                    <Route path="/template-variables" element={<TemplateVariablesPage />} />
                    <Route path="/dpi-catalog" element={<DpiCatalogPage />} />
                    <Route path="/docx-templates-manager" element={<DocxTemplatesManagerPage />} />
                    <Route path="/documents-matrix" element={<DocumentsMatrixPage />} />
                    <Route path="/medical-visits" element={<MedicalVisitsPage />} />
                    <Route path="/training-materials" element={<TrainingMaterialsPage />} />
                    <Route path="/attendance-registers" element={<AttendanceRegistersPage />} />
                    <Route path="/training-sessions" element={<TrainingSessionsPage />} />
                    <Route path="/register-templates" element={<RegisterTemplatesPage />} />
                    <Route path="/safety-programs" element={<SafetyProgramsPage />} />
                    <Route path="/studio" element={<StudioDashboardPage />} />
                    <Route path="/studio/clienti" element={<StudioClientiPage />} />
                    <Route path="/studio/commesse" element={<StudioCommessePage />} />
                    <Route path="/studio/preventivi" element={<StudioPreventiviPage />} />
                    <Route path="/studio/pagamenti" element={<StudioPagamentiPage />} />
                    <Route path="/studio/scadenze" element={<StudioScadenzePage />} />
                    <Route path="/studio/insegne" element={<StudioInsegnePage />} />
                    <Route path="/studio/fatture" element={<FatturePage />} />
                    <Route path="/studio/modulistica" element={<ModulisticaPratichePage />} />
                    <Route path="/studio/contratti" element={<ContractsPage />} />
                    <Route path="/studio/piattaforme-formazione" element={<PlatformsPage />} />
                    <Route path="/studio/agente-collab" element={<AgenteCollabIscrizioniPage />} />
                    <Route path="/haccp/verbali-asl" element={<VerbaliAslPage />} />
                    <Route path="/haccp/manuali" element={<HaccpManualePage />} />
                    <Route path="/studio/prevenzione-incendi" element={<PrevenzioneIncendiPage />} />
                    <Route path="/admin/template-editor" element={<TemplateEditorPage />} />
                    <Route path="/admin/online-users" element={<OnlineUsersPage />} />
                    <Route path="/studio/delega-docfa" element={<DelegaDocfaPage />} />
                    <Route path="/haccp/libro-ingredienti" element={<LibroIngredientiPage />} />
                    <Route path="/haccp/schede-prodotto-da-rapporti" element={<SchedeProdottoPage />} />
                    <Route path="/formazione/gestione-template" element={
                      <TemplateEditorPage
                        onlyCategories={['registri', 'attestati']}
                        pageTitle="Gestione Template Registri & Attestati"
                        pageSubtitle="Anteprima formattata e modifica inline dei template Word usati per i registri presenza e gli attestati di formazione."
                      />
                    } />
                    <Route path="/signflow" element={<SignFlowPage />} />
                    <Route path="/studio/impianti-audiovisivi" element={<ImpiantiAudiovisiviPage />} />
                    <Route path="/docente-keys" element={<DocenteKeysPage />} />
                    <Route path="/diagnostica" element={<DiagnosticaPage />} />
                    <Route path="/sicurezza/piani-sanitari" element={<PianiSanitariPage />} />
                    <Route path="/sicurezza/piani-sanitari/:piano_id" element={<PianoSanitarioDetailPage />} />
                    <Route path="/profilo/firma-timbro" element={<UserSignaturePage />} />
                    <Route path="/haccp/matrice-prelievi" element={<MatricePrelieviPage />} />
                    <Route path="/studio/deleghe" element={<DelegheePage />} />
                    <Route path="/docente/ppt" element={<DocentePptPage />} />
                    <Route path="/notifiche" element={<NotificationSettingsPage />} />
                    <Route path="/haccp/schede-tecniche" element={<HaccpSchedeTecnichePage />} />
                    <Route path="/haccp/dichiarazione" element={<DichiarazioneHaccpPage />} />
                    <Route path="/sicurezza/dichiarazione-luoghi-lavoro" element={<DichiarazioneSicurezzaPage />} />
                    <Route path="/haccp/verbali-prelievo" element={<VerbaliPrelievoPage />} />
                    <Route path="/haccp/schede-preoperative" element={<SchedePreoperativeHaccpPage />} />
                    <Route path="/studio/calendario" element={<CalendarioImpegniPage />} />
                    <Route path="/professionista" element={<ProfessionistaPage />} />
                    <Route path="/training-certificates" element={<TrainingCertificatesPage />} />
                    <Route path="/medical-records" element={<MedicalRecordsPage />} />
                    <Route path="/employees-overview" element={<EmployeesOverviewPage />} />
                    <Route path="/ground-inspections" element={<GroundInspectionsPage />} />
                    <Route path="/notifications-settings" element={<NotificationsSettingsPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    {/* v1.0.1: catch-all per route eliminate (es. /studio/iscrizione-massiva, /bulk-enrollment, /docente-keys, /studio/email-templates, /studio/rubrica-discenti, ecc.) → redirect a dashboard */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" richColors duration={1000} />
      </BrowserRouter>
      </CurrentPdvProvider>
    </AuthProvider>
  );
}

export default App;
